export default {
  getDefaultState: () => ({
    secrets: [],
  }),
  getSecrets: (state) => state.secrets,
};
